import Joi from 'joi';

import { IImageMapProps } from './models';

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional();
const uriRequired = Joi.string().uri().required();
const imgSchema = {
  url: uriRequired,
  filename: Joi.string().required(),
};
const requiredImageSchema = Joi.object(imgSchema).required();
const optionalImageSchema = Joi.object(imgSchema).optional();

export const imageMapSchema = Joi.object<IImageMapProps>({
  subTitle: stringRequired,
  text: stringOptional,
  sourceImageAlt: stringRequired,
  sourceImage: requiredImageSchema,
  sourceImageWidth: stringRequired,
  sourceImageHeight: stringRequired,
  imageMapClass: stringRequired,
  imageBg: optionalImageSchema,
  imageBgAlt: stringOptional,
}).options({ stripUnknown: true });
